import { icons } from "@patient-watch/icons";
import { cn } from "@/lib/utils";
import type { ToT } from "@/route-types";
import { useNavigate } from "@tanstack/react-router";
import { toast } from "@patient-watch/ui/sonner";
import { useToastCopy } from "@/features/i18n/toastCopy";
import { warningColors } from "../../utils/warningColors";
import { EditPencil } from "@patient-watch/ui/edit-pencil";

const boolmap = (val: boolean) => {
    if (val === true) {
        return "Yes";
    }
    if (val === false) {
        return "No";
    }
};

interface Props {
    label?: string;
    noInfo?: boolean;
    info: string | React.ReactNode;
    help?: () => void;
    locked?: boolean;
    tabIndex?: number;
    show: boolean;
    backRoute?: ToT;
    route: ToT;
    description?: string;
}

const EditRow = ({ label, info, help, locked, tabIndex, show, route, noInfo, description }: Props) => {
    const navigate = useNavigate();
    const toastCopy = useToastCopy();

    if (!show) {
        return <></>;
    }

    const missingInfo = (!info || !!noInfo) ?? false;

    return (
        <button
            type="button"
            onClick={() => (locked ? toast.error(toastCopy.profileAttributeLocked) : navigate(route))}
            tabIndex={tabIndex}
            disabled={locked}
            className={cn(
                "flex justify-between items-center my-2 w-full",
                locked ? "cursor-not-allowed" : "cursor-pointer"
            )}
        >
            <div className="w-3/4">
                {label && (
                    <p className={cn("my-1 p-0 w-full font-semibold text-sm text-left", warningColors(missingInfo))}>
                        {label}
                        {help && (
                            <button type="button" onClick={help} aria-label="Help">
                                <icons.Question />
                            </button>
                        )}
                    </p>
                )}
                {description && <p className="text-slate-600 text-sm text-left">{description}</p>}

                <p className={cn("my-1 p-0 w-full text-lg text-left", warningColors(missingInfo))}>
                    {info === null || info === undefined || info === ""
                        ? "Information Missing"
                        : typeof info === "boolean"
                          ? boolmap(info)
                          : info}
                </p>
            </div>
            <EditPencil locked={locked} />
        </button>
    );
};

export default EditRow;
